module.exports = __webpack_public_path__ + "2051e34f42931b9ffd4bedb22750121b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mesopotamia-jones.png
// module id = JNfK
// module chunks = 0